import "./Message.css";
import React, { useEffect, useState } from "react";
import Message from "@sendbird/uikit-react/Channel/components/Message";
import { ReactComponent as PatientProfile } from "../../../../img/patientProfile.svg";
import { ReactComponent as DoctorProfile } from "../../../../img/DrProfile.svg";
import ReceptionistProfileImg from "../../../../img/receptionist.png";

import moment from "moment/moment";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const millisecondsToTime = (milliseconds) => {
  return moment(milliseconds).format("LT");
};

const millisecondsToDate = (milliseconds) => {
  if (
    moment(milliseconds).format("DD/MM/YYYY") == moment().format("DD/MM/YYYY")
  ) {
    return "TODAY";
  } else if (
    moment(milliseconds).format("DD/MM/YYYY") ==
    moment().subtract(1, "days").format("DD/MM/YYYY")
  ) {
    return "YESTERDAY";
  } else return moment(milliseconds).format("DD/MM/YYYY");
};

const MessageComponent = ({
  message,
  isFromAdmin,
  previousMessageDate,
  markAsAdminMessageCallback,
}) => {
  const [isShowDate, setIsShowDate] = useState(true);
  console.log(message);

  const [messageOptionsAnchorEl, setMessageOptionsAnchorEl] = useState(null);
  const open = Boolean(messageOptionsAnchorEl);

  const handleClick = (event) => {
    setMessageOptionsAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setMessageOptionsAnchorEl(null);
  };

  useEffect(() => {
    if (millisecondsToDate(message.createdAt) === previousMessageDate.current) {
      setIsShowDate(false);
    }
    previousMessageDate.current = millisecondsToDate(message.createdAt);
  }, []);

  if (message.data === "hide") return <></>;

  return (
    <>
      {isShowDate && (
        <div
          style={{
            margin: "10px auto 0px auto",
            fontSize: "14px",
            width: "fit-content",
            color: "#707070",
          }}
        >
          {millisecondsToDate(message.createdAt)}
        </div>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: isFromAdmin ? "row-reverse" : "row",
        }}
      >
        <div style={{ padding: "10px" }}>
          {isFromAdmin ? (
            message?.sender?.plainProfileUrl ? (
              <img
                style={{ height: "50px", width: "50px", borderRadius: "50%" }}
                src={message.sender.plainProfileUrl}
              />
            ) : (
              <div
                style={{
                  backgroundColor: "var(--lightbluecolrtwenty)",
                  borderRadius: "50%",
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img style={{ height: "80%" }} src={ReceptionistProfileImg} />
              </div>
            )
          ) : (
            <PatientProfile style={{ height: "30px", width: "30px" }} />
          )}
        </div>
        {message.messageType === "file" ? (
          <Message message={message} />
        ) : (
          <div
            style={{
              width: "100%",
              padding: "10px",
              paddingBottom: "20px",
              backgroundColor: isFromAdmin ? "#DBFAD9" : "#EAF6FE",
              marginTop: "10px",
              border: "1px solid #00000019",
              borderRadius: "5px",
              position: "relative",
            }}
          >
            {message.message}
            {/* {!isFromAdmin && (
              <>
                <IconButton
                  style={{ position: "absolute", right: "10px", top: "-10px" }}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <ExpandMoreIcon />
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={messageOptionsAnchorEl}
                  keepMounted
                  open={Boolean(messageOptionsAnchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem
                    onClick={() => {
                      markAsAdminMessageCallback(message.messageId);
                    }}
                  >
                    Mark as Admin message
                  </MenuItem>
                </Menu>
              </>
            )} */}
            <div
              style={{
                font: "normal normal normal 12px Segoe UI",
                letterSpacing: "0px",
                color: "#707070",
                position: "absolute",
                right: "10px",
                bottom: "10px",
              }}
            >
              {millisecondsToTime(message.createdAt)}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MessageComponent;
